import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';

import { LoadingScreen } from 'src/components/loading-screen';

const FileViewerPlayground = lazy(() => import('src/pages/playground/file-viewer'));
const TakehomeReviewPlayground = lazy(() => import('src/pages/playground/takehome-review'));

export const playgroundRoutes: RouteObject[] = [
  {
    path: '/playground',
    children: [
      {
        path: 'file-viewer',
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <FileViewerPlayground />
          </Suspense>
        ),
      },
      {
        path: 'takehome-review',
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <TakehomeReviewPlayground />
          </Suspense>
        ),
      },
    ],
  },
];
